import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import heroBg from "@/assets/hero-bg.jpg";

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-foreground/95 via-foreground/85 to-foreground/60" />
      </div>

      <div className="container relative z-10 py-28">
        <div className="max-w-2xl">
          {/* Main Heading - bigger, cleaner */}
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold text-primary-foreground leading-[1.1] mb-8 animate-fade-up">
            Learn Skills,{" "}
            <span className="text-gradient-gold">Earn Money</span>
          </h1>

          {/* Subheading - concise */}
          <p className="text-lg md:text-xl text-primary-foreground/75 mb-12 max-w-lg leading-relaxed animate-fade-up" style={{ animationDelay: '0.1s' }}>
            Pay once, access all courses forever. Earn ₦4,000 for every friend you refer.
          </p>

          {/* Single primary CTA */}
          <div className="animate-fade-up" style={{ animationDelay: '0.2s' }}>
            <Link to="/signup">
              <Button variant="gold" size="xl">
                Start Learning
                <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
          </div>

          {/* Minimal social proof */}
          <div className="flex flex-wrap items-center gap-x-8 gap-y-4 mt-16 pt-8 border-t border-primary-foreground/10 animate-fade-up" style={{ animationDelay: '0.3s' }}>
            <div>
              <p className="text-xl sm:text-2xl font-bold text-primary-foreground">10,000+</p>
              <p className="text-xs sm:text-sm text-primary-foreground/50 mt-1">Active Learners</p>
            </div>
            <div className="hidden sm:block h-10 w-px bg-primary-foreground/15" />
            <div>
              <p className="text-xl sm:text-2xl font-bold text-primary-foreground">50+</p>
              <p className="text-xs sm:text-sm text-primary-foreground/50 mt-1">Premium Courses</p>
            </div>
            <div className="hidden sm:block h-10 w-px bg-primary-foreground/15" />
            <div>
              <p className="text-xl sm:text-2xl font-bold text-accent">₦4,000</p>
              <p className="text-xs sm:text-sm text-primary-foreground/50 mt-1">Per Referral</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
